import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavbarComponent } from './layout/navbar/navbar.component';
import { RodapeComponent } from './layout/rodape/rodape.component';
import { RouterModule } from '@angular/router';
import { SafeHtmlPipe } from './pipe/safe-html.pipe';
import { RigthAreaComponent } from './layout/rigth-area/rigth-area.component';
import { CarouselHomeComponent } from './layout/carousel-home/carousel-home.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PesquisaComponent } from './layout/navbar/pesquisa/pesquisa.component';
import { FormsModule } from '@angular/forms';
import { HeaderComponent } from './layout/header/header.component';
import { ContentAreaComponent } from './layout/content-area/content-area.component';

@NgModule({
  imports: [
    CommonModule,
    NgxExtendedPdfViewerModule,
    RouterModule,
    FormsModule,
  ],
  declarations: [
    NavbarComponent,
    RodapeComponent,
    SafeHtmlPipe,
    RigthAreaComponent,
    CarouselHomeComponent,
    PesquisaComponent,
    HeaderComponent,
    ContentAreaComponent,
  ],
  exports: [
    NavbarComponent,
    RodapeComponent,
    RigthAreaComponent,
    SafeHtmlPipe,
    NgxExtendedPdfViewerModule,
    CarouselHomeComponent,
    HeaderComponent,
    ContentAreaComponent,
  ],
})
export class SharedModule {}
